import React, { useLayoutEffect } from "react";
import Kawaii from "../components/blob/Kawaii";
import { motion } from "framer-motion";
// React Helmet
import { Helmet, HelmetProvider } from 'react-helmet-async';

function VideoE() {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <HelmetProvider>
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: "0.5s all ease" }}
      exit={{ opacity: 0 }}
      className="carrer__div1"
    >
      <Helmet>
      {/* <!-- Primary Meta Tags --> */}
<title>Video Editor - iGeeks Media</title>
<meta name="title" content="Video Editor - iGeeks Media" />
<meta name="description" content="We love a crisp video as much as you do. We are looking for a video editor who can edit reels as well as hour-long podcasts. Join us today." />

{/* <!-- Open Graph / Facebook --> */}
<meta property="og:type" content="website" />
<meta property="og:url" content="https://www.igeeksmedia.com/video-editor/" />
<meta property="og:title" content="Video Editor - iGeeks Media" />
<meta property="og:description" content="We love a crisp video as much as you do. We are looking for a video editor who can edit reels as well as hour-long podcasts. Join us today." />
<meta property="og:image" content="" />

{/* <!-- Twitter --> */}
<meta property="twitter:card" content="summary_large_image" />
<meta property="twitter:url" content="https://www.igeeksmedia.com/video-editor/" />
<meta property="twitter:title" content="Video Editor - iGeeks Media" />
<meta property="twitter:description" content="We love a crisp video as much as you do. We are looking for a video editor who can edit reels as well as hour-long podcasts. Join us today." />
<meta property="twitter:image" content="" />
      </Helmet>
      <div className="carrer__div2">
        <div className="home__div4">
          <div className="home__div000">
            <Kawaii />
          </div>
          <div className="home__div5"></div>
          <div className="carrer__div8000 title_line">
            <p>
              <span>Video </span>
              <span>Editor</span>
            </p>
          </div>
        </div>
      </div>
      <div className="staff__div1">
        <div className="arrer__extra1">
          <div className="carrer__div9"></div>
          <div className="carrer__div10">
            <div className="carrer__div11">
              <div className="carrer__div12">
                <p>Writing</p>
              </div>
              <div className="carrer__div13">
                <p>Video Editor</p>
              </div>
            </div>
            <div className="carrer__div14">
              <div className="carrer__div15">
                <p>About</p>
              </div>
              <div className="carrer__div16">
                <p>
                We are hiring for a skilled video editor with tech knowledge. Interested candidates should have an understanding of shooting product videos, podcast episodes, reels and more. Brownie points if you have experience working for a tech channel before.
                </p>
              </div>
            </div>
            <div></div>
          </div>
        </div>
      </div>
      <div className="staff__div2">
        <div className="staff__div3">
          <p>Interested?</p>
          <div className="apply_Button">
            <a href="mailto:hr@igeeksmedia.com" target="_blank" rel="noreferrer">Apply Now</a>
          </div>
        </div>
        <div className="staff__div4">
          <p>Requirements:</p>
          <div className="staff__div5">
            <div className="staff__div6">
              <p>Key Responsibilities:</p>
            </div>
            <div className="staff__div7">
              <ul>
                <li>
                  Take a brief to grasp production team’s needs and
                  specifications
                </li>
                <li>
                  Review shooting script and raw material to create a shot
                  decision list based on scenes’ and final video
                </li>
                <li>
                  Trim footage segments and put together the sequence of the
                  film
                </li>
                <li>
                  Input music, dialogues, graphics and effects based on scripts
                </li>
                <li>Create rough and final cuts</li>
                <li>Ensure logical sequencing and smooth running film</li>
                <li>
                  Continuously discover and implement new editing technologies
                  and industry’s best practices to maximize efficiency.
                </li>
              </ul>
            </div>
          </div>
          <div className="staff__div50">
            <div className="staff__div6">
              <p>Skills set to get succeed:</p>
            </div>
            <div className="staff__div7">
              <ul>
                <li>3+ Years of proven work experience as a video editor</li>
                <li>
                  Demonstrable video editing ability with a strong portfolio
                </li>
                <li>
                  Familiarity with after effects, adobe premier, and final cur
                  pro
                </li>
                <li>Creative mind and storytelling skills</li>
                <li>Good command over english is must</li>
                <li>Bachelor degree with course in video editing</li>
                <li>
                  Cinematography, YouTuber or worked for YouTuber will be added
                  advantage
                </li>
              </ul>
            </div>
          </div>
          {/* <div className="staff__div50">
            <div className="staff__div6">
              <p>What will you get in return?</p>
            </div>
            <div className="staff__div7">
              <ul>
                <li>Flexible Timing</li>
                <li>Family Mediclaim & Accident Policy</li>
                <li>
                  A share in our success - Get a chance to receive a profit pool
                  bonus at the end of our financial year
                </li>
                <li>
                  Healthy snacks, fruits, beverages and lunch on every working
                  Saturday.
                </li>
                <li>
                  Fitness facilities (gym, yoga membership) at discount price
                </li>
                <li>
                  Free digital magazine subscriptions of Magzter/Bookazines
                </li>
                <li>
                  While working you can refresh yourself by playing Foosball,
                  tabled basketball, or compete with other on Xbox/Play Station.
                </li>
                <li>Library access</li>
              </ul>
            </div>
          </div> */}
        </div>
      </div>
    </motion.div>
    </HelmetProvider>
  );
}

export default VideoE;
